import { InputSelectOptions, InputField } from 'components'
import AddressFormField from 'domains/address/organisms/address-form-field'
import ContractField from 'domains/merchant/molecules/contract-field'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
import merchantSchema from 'domains/merchant/organisms/merchant-form/merchant-schema'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Button, Col, Row } from 'reactstrap'


const propTypes = {
  merchant: PropTypes.shape({
    id                   : PropTypes.number,
    name                 : PropTypes.string,
    username             : PropTypes.string,
    email                : PropTypes.string,
    phone_number         : PropTypes.string,
    bank                 : PropTypes.string,
    bank_branch          : PropTypes.string,
    account_number       : PropTypes.string,
    account_name         : PropTypes.string,
    merchant_type        : PropTypes.string,
    merchant_contract_id : PropTypes.number,
    inbound_fee          : PropTypes.string,
    address              : PropTypes.shape({
      id                 : PropTypes.number,
      street_address     : PropTypes.string,
      tl_province_id     : PropTypes.number,
      tl_city_id         : PropTypes.number,
      tl_district_id     : PropTypes.number,
      tl_sub_district_id : PropTypes.number,
      postal_code        : PropTypes.string
    })
  }),
  buttonText       : PropTypes.string.isRequired,
  handleSubmitForm : PropTypes.func.isRequired
}

const defaultProps = {
  merchant: {
    id                   : null,
    name                 : '',
    username             : '',
    email                : '',
    phone_number         : '',
    bank                 : '',
    bank_branch          : '',
    account_number       : '',
    account_name         : '',
    merchant_type        : '',
    merchant_contract_id : -1,
    inbound_fee          : '',
    address              : {
      id                 : -1,
      street_address     : '',
      tl_province_id     : -1,
      tl_city_id         : -1,
      tl_district_id     : -1,
      tl_sub_district_id : -1,
      postal_code        : ''
    }
  },
  buttonText       : 'Submit',
  handleSubmitForm : () => {}
}

const MerchantForm = ({
  merchant,
  buttonText,
  handleSubmitForm
}) => {
  const [ inboundFeeVisible, setInboundFeeVisible ] = useState(merchant.merchant_type === MERCHANT_TYPE.MERCHANT_FULL ? true : false)

  const fieldNames = {
    streetAddress : 'address.street_address',
    provinceId    : 'address.tl_province_id',
    cityId        : 'address.tl_city_id',
    districtId    : 'address.tl_district_id',
    subDistrictId : 'address.tl_sub_district_id',
    postalCode    : 'address.postal_code'
  }

  const address = {
    provinceId : merchant.address.tl_province_id ? merchant.address.tl_province_id : -1,
    cityId     : merchant.address.tl_city_id ? merchant.address.tl_city_id : -1,
    districtId : merchant.address.tl_district_id ? merchant.address.tl_district_id : -1
  }

  // change visisibility of inbound fee based on merchant type
  // only show inbound fee for merchant full
  const handleShowInboundFee = (event) => {
    const selectedIndex = event.nativeEvent.target.selectedIndex
    const value         = event.nativeEvent.target[selectedIndex].value
    if (value !== MERCHANT_TYPE.MERCHANT_LIST) {
      setInboundFeeVisible(true)
    }
    else {
      setInboundFeeVisible(false)
    }
  }

  return (
    <div>
      <Formik
        enableReinitialize= { true }
        initialValues={ merchant }
        validationSchema={ merchantSchema }
        onSubmit={ (values, formikBag) => handleSubmitForm(values, formikBag) }
      >
        {
          (formikBag) => (
            <Form>
              <Row>
                <Col>
                  <InputField
                    type='text'
                    name='name'
                    label='Name'
                    placeholder='Tinkerlust'
                    required={ true }
                  />
                  <InputField
                    type='text'
                    name='username'
                    label='Username'
                    placeholder='username123'
                    required={ true }
                    disabled={ merchant.id ? true : false }
                  />
                  <InputField
                    type='text'
                    name='email'
                    label='Email'
                    placeholder='tinkerlust@gmail.com'
                    required={ true }
                  />
                  <InputField
                    type='tel'
                    name='phone_number'
                    label='Phone Number'
                    placeholder='0821xxxxxx'
                    required={ true }
                  />
                  <InputField
                    type='string'
                    name='bank'
                    label='Bank Name'
                    placeholder='BCA'
                    required={ true }
                  />
                  <InputField
                    type='text'
                    name='bank_branch'
                    label='Bank Branch'
                    placeholder='KCP Pasar Cikini'
                    required={ true }
                  />
                  <InputField
                    type='number'
                    name='account_number'
                    label='Account Number'
                    placeholder='0329009779'
                    required={ true }
                  />
                  <InputField
                    type='text'
                    name='account_name'
                    label='Account Name'
                    placeholder='Cindy Perdana Kusuma'
                    required={ true }
                  />
                </Col>

                <Col>
                  <AddressFormField
                    address= { address }
                    formikBag={ formikBag }
                    fieldNames={ fieldNames }
                  />
                  <InputField
                    type='select'
                    name='merchant_type'
                    label='Merchant Type'
                    required={ true }
                    onChange={ (event) => {
                      formikBag.handleChange(event)
                      handleShowInboundFee(event)
                    } }
                  >
                    <InputSelectOptions options={ MERCHANT_TYPE } keyPrefix={ 'merchant-type' } />
                  </InputField>
                  <ContractField
                    formikBag={ formikBag }
                    fieldName={ 'merchant_contract_id' }
                    merchantType={ formikBag.values.merchant_type }
                  />
                  {
                    inboundFeeVisible
                      ?
                      <InputField
                        type='select'
                        name='inbound_fee'
                        label='Inbound Fee'
                        required={ true }
                      >
                        <option key={ 'default-boolean' } value=''>Choose one</option>
                        <option key={ 'boolean-options-true' } value={ true }>Yes</option>
                        <option key={ 'boolean-options-false' } value={ false }>No</option>
                      </InputField>
                      : null
                  }

                  <Button
                    color='primary'
                    disabled={ formikBag.isSubmitting }
                    onClick={ () => formikBag.submitForm() }
                  >
                    {
                      formikBag.isSubmitting
                        ? <i className="ni ni-settings-gear-65 spin"/>
                        : buttonText
                    }
                  </Button>
                </Col>
              </Row>
              <Row>

              </Row>
            </Form>
          )
        }
      </Formik>
    </div>
  )
}

MerchantForm.propTypes    = propTypes
MerchantForm.defaultProps = defaultProps

export default MerchantForm